/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { useGlobalSearch, useProcess } from "@/global-data";
import { useDeletePopup } from "@/global-data/use-delete-popup";
import { useDebouncedValue } from "@/hooks/use-debounced-value";
import { getUserInfo } from "@/lib/token";
import { wait } from "@/lib/wait";
import { apiServices } from "@/services/api.services";
import { useEffect, useMemo, useState } from "react";
import {
  companies,
  snc_customers,
  snc_erp_uom,
  workflow,
} from "@/services/global.services";
import { useToast } from "@/hooks/use-toast";
import { getJobId } from "@/lib/utils";
// import { Value } from "@radix-ui/react-select";

export const useMutations = () => {
  const API_SERVICE = useMemo(() => {
    return companies;
  }, [companies]);

  const { user_id, company_id } = useMemo(() => {
    const tempUserData = getUserInfo();
    return {
      company_id: tempUserData?.company_id,
      user_id: tempUserData?.user_id || "",
    };
  }, []);

  const [activeTab, setActiveTab] = useState("company_settings");

  const [tabList] = useState([
    {
      label: "Company Settings",
      id: "company_settings",
    },
    {
      label: "Erp Settings",
      id: "erp_settings",
    },
  ]);

  const { setProcess } = useProcess();
  const [skeltonLoading, setSkeltonLoading] = useState(true);
  const [companyData, setCompanyData] = useState<any>([]);
  const [workflowList, setWorkflowList] = useState<any>([]);
  const [sncErpUomList, setSncErpUomList] = useState<any>([]);
  const [formPopupOpen, setFormPopupOpen] = useState(false);
  const [activeRecordData, setActiveRecordData] = useState(undefined);
  const [tableColumn, setTableColumn] = useState([]);
  const [sncCustomerList, setSncCustomerList] = useState([]);
  const [skuList, setSkuList] = useState([]);

  const order_status_list = [
    {
      label: "Pending",
      value: "Pending",
    },
    {
      label: "Partially Picked",
      value: "Partially Picked",
    },
    {
      label: "Picked",
      value: "Picked",
    },
    {
      label: "Packed",
      value: "Packed",
    },
    {
      label: "Shipped",
      value: "Shipped",
    },
    {
      label: "Cancelled",
      value: "Cancelled",
    },
    {
      label: "Return Processing",
      value: "Return Processing",
    },
    {
      label: "Returned",
      value: "Returned",
    },
    {
      label: "Completed",
      value: "Completed",
    },
  ];

  const { setSearchProgress, search } = useGlobalSearch();
  const { toast } = useToast();
  const [searchDebounced] = useDebouncedValue(search, 200);

  const { onDelete, status, identity, id, clearDelete } = useDeletePopup();
  const [isSncCustomerLoaded, setIsSncCustomerLoaded] = useState(false);
  const [paginationData, setPaginationData] = useState({
    page: 1,
    perPage: 100,
    totalItem: 1,
  });

  //On Load Component
  useEffect(() => {
    (async () => {
      setProcess(true);
      await loadingUsers();
      await wait(1000);
      setSkeltonLoading(false);
      setProcess(false);
    })();
  }, []);

  const onErpSettingsTabChange = async () => {
    if (
      isSncCustomerLoaded === false &&
      companyData?.settings?.erp_price_validations &&
      activeTab === "erp_settings"
    ) {
      console.log({
        companyData: companyData?.settings?.erp_price_validations,
      });
      setProcess(true);
      await loadSNCustomer();
      setIsSncCustomerLoaded(true);
      setProcess(false);
    }
  };

  //handle delete
  useEffect(() => {
    if (status === "cancel") {
      clearDelete();
    }
    if (status === "delete" && identity === "user") {
      alert(JSON.stringify(id));
      clearDelete();
    }
  }, [status]);

  //Handle Search
  useEffect(() => {
    if (skeltonLoading === false) {
      (async () => {
        setSearchProgress(true);
        await loadingUsers();
        setSearchProgress(false);
      })();
    }
  }, [searchDebounced]);

  const onFormOpenChange = (prop: boolean) => {
    setFormPopupOpen(prop);
  };

  const onPageChange = async (prop: number) => {
    setPaginationData((prev) => ({ ...prev, page: prop }));
    setProcess(true);
    await loadingUsers();
    setProcess(false);
  };
  const onPerPageChange = async (prop: number) => {
    setPaginationData((prev) => ({ ...prev, perPage: prop, page: 1 }));
    setProcess(true);
    await loadingUsers();
    setProcess(false);
  };

  const permission: any = [];
  const onAction = async ({ action, data }: any) => {
    if (action === "edit") {
      setActiveRecordData(data);
      onFormOpenChange(true);
    }
    if (action === "delete") {
      setActiveRecordData(data);

      onDelete({
        description:
          "This action cannot be undone. This will permanently delete the record and remove its data from our system.",
        id: data.user_id,
        identity: "user",
        popupStatus: true,
        title: "Are you sure you want to delete this setting?",
      });
      await loadingUsers();
    }
  };

  useEffect(() => {
    if (formPopupOpen === false) {
      setActiveRecordData(undefined);
    }
  }, [formPopupOpen]);

  const loadingUsers = async (prop?: any) => {
    const payload = {
      data: {
        filter_by: {
          company_id: [company_id],
          search_text: "",
          exact_match: false,
        },
      },
      company_id: company_id,
      user_id: user_id,
    };
    const { data, error, message } = await apiServices<any>(
      API_SERVICE.get,
      "post",
      payload,
    );

    if (data) {
      const tempData: any = data.result.metadata[API_SERVICE.key][0];
      // const newTempData =
      //   tempData.settings.duplicate_order_settings.amend_and_push_duplicate;
      // // console.log({ newTempData });
      tempData.settings = {
        ...tempData.settings,
        amend_and_push_duplicate:
          tempData.settings.duplicate_order_settings.amend_and_push_duplicate,
        do_not_push_duplicate:
          tempData.settings.duplicate_order_settings.do_not_push_duplicate,
        push_duplicate:
          tempData.settings.duplicate_order_settings.push_duplicate,
        show_branch_id:
          tempData.settings.customer_mapping_settings?.show_branch_id,
      };

      setSkuList(tempData.sku_list || []);
      if (!prop) {
        setCompanyData(tempData);
      }
      await loadingWorkflow();
      await loadingSncErpUom();
    }
    if (error) {
      toast({
        title: "Error",
        variant: "destructive",
        description: error.status?.message || message,
      });
    }
    return { data, error };
  };
  const loadingWorkflow = async () => {
    const payload = {
      data: {
        filter_by: {
          company_id: [company_id],
          search_text: "",
          exact_match: false,
        },
      },
      company_id: company_id,
      user_id: user_id,
    };
    const { data, error, message } = await apiServices<any>(
      workflow.get,
      "post",
      payload,
    );

    if (data) {
      setWorkflowList(data.result.metadata[workflow.key]);
    }
    if (error) {
      toast({
        title: "Error",
        variant: "destructive",
        description: error.status?.message || message,
      });
    }
    return { data, error };
  };
  const loadingSncErpUom = async () => {
    const payload = {
      data: {
        filter_by: {
          company_id: [company_id],
          search_text: "",
          exact_match: false,
        },
      },
      company_id: company_id,
      user_id: user_id,
    };
    const { data, error, message } = await apiServices<any>(
      snc_erp_uom.get,
      "post",
      payload,
    );

    if (data) {
      // console.log(data.result.metadata);
      setSncErpUomList(data.result.metadata[snc_erp_uom.key]);
    }
    if (error) {
      toast({
        title: "Error",
        variant: "destructive",
        description: error.status?.message || message,
      });
    }
    return { data, error };
  };

  const loadSNCustomer = async () => {
    const payload = {
      data: {
        pull_from_db: true,
        filter_by: {
          company_id: [company_id],
          search_text: "",
          exact_match: false,
        },
      },
      company_id: company_id,
      user_id: user_id,
    };
    const { data, error, message } = await apiServices<any>(
      snc_customers.get,
      "post",
      payload,
    );

    if (data) {
      setSncCustomerList(data.result.metadata[snc_customers.key]);
    }
    if (error) {
      toast({
        title: "Error",
        variant: "destructive",
        description: error.status?.message || message,
      });
    }
    return { data, error };
  };

  // const getJobId = async (prop: string, isInProgressExist?: boolean) => {
  //   while (true) {
  //     const { data, error, message } = await apiServices<any>(
  //       jobId.get + prop,
  //       "get",
  //     );

  //     if (data?.process_status !== "in-progress" || isInProgressExist) {
  //       if (data?.error) {
  //         toast({
  //           title: "Error",
  //           variant: "destructive",
  //           description: error.status?.message || message,
  //         });
  //       }

  //       if (data?.status?.error_details?.fail_message) {
  //         toast({
  //           title: "Error",
  //           variant: "destructive",
  //           description: data.status.error_details.fail_message,
  //         });
  //         return { data: null, error: data.status.error_details.fail_message };
  //       }

  //       return { data, error };
  //     }

  //     await new Promise((resolve) => setTimeout(resolve, 5000)); // Wait for 5 seconds before next call
  //   }
  // };

  const onFormSubmit = async (prop: any): Promise<any> => {
    if (prop.erp_enabled === false) {
      prop.erp_price_validations = false;
      prop.erp_sku_validations = false;
      prop.sku_similarity_search = false;
      prop.customer_sku_search = false;
      prop.erp_uom_validations = false;
    }
    const payload = {
      data: {
        company_id: companyData.company_id,
        settings: {
          openapi_key: companyData.openapi_key,
          erp_enabled: prop.erp_enabled,
          premium_limit: prop.premium_limit,
          premium_used: prop.premium_used,
          erp_price_validations: prop.erp_price_validations,
          ignore_price_validations: prop.ignore_price_validations,
          erp_sku_validations: prop.erp_sku_validations,
          sku_similarity_search: prop.sku_similarity_search,
          customer_sku_search: prop.customer_sku_search,
          erp_uom_validations: prop.erp_uom_validations,
          default_workflow: prop.default_workflow,
          order_status: prop.order_status,
          default_uom: prop.default_uom,
          reference_number_prefix: prop.reference_number_prefix,
          snc_username: prop.snc_username,
          snc_password: prop.snc_password,
          ignore_validation_failure: prop.ignore_validation_failure,
          support_multi_doc_type: prop.support_multi_doc_type,
          push_flagged_documents: prop.push_flagged_documents,
          decimal_places:
            prop.decimal_places === "" ||
            prop.decimal_places === null ||
            prop.decimal_places === undefined
              ? null
              : +prop.decimal_places,
          amount_decimal_places:
            prop.amount_decimal_places === "" ||
            prop.amount_decimal_places === null ||
            prop.amount_decimal_places === undefined
              ? null
              : +prop.amount_decimal_places,
          duplicate_order_settings: {
            amend_and_push_duplicate: prop.amend_and_push_duplicate,
            do_not_push_duplicate: prop.do_not_push_duplicate,
            push_duplicate: prop.push_duplicate,
          },
          detect_chinese_text: prop.detect_chinese_text,
          disable_snc_auto_push: prop.disable_snc_auto_push,
          customer_mapping_settings: {
            show_branch_id: prop.show_branch_id,
          },
          multi_doc_detection_keys: prop.support_multi_doc_type
            ? prop.multi_doc_detection_keys
            : null,
          match_sale_history_uom_by_sku: prop.match_sale_history_uom_by_sku,
          show_deleted_documents: prop.show_deleted_documents,
          comments: prop.comments,
          // Set from the Company page; kept so saving here does not clear it
          country: companyData?.settings?.country,
          workflow_settings: {
            solution_id: prop.workflow_settings?.solution_id,
            username: prop.workflow_settings?.username,
            password: prop.workflow_settings?.password,
          },
        },
      },
      company_id: companyData.company_id,
      user_id: user_id,
    };

    if (prop.snc_password === "") {
      delete payload.data.settings.snc_password;
    }

    if (!prop.workflow_settings?.password) {
      delete payload.data.settings.workflow_settings.password;
    }

    const { data, error /* message */ } = await apiServices<any>(
      API_SERVICE.post,
      "post",
      payload,
    );

    if (data?.job_id) {
      const jobIdResponse = await getJobId(data.job_id);
      if (jobIdResponse.error) {
        return jobIdResponse;
      }
      const getResponse = await loadingUsers();
      if (getResponse.error) {
        return getResponse;
      }
    }

    if (error) {
      setProcess(false);
    }
    return { data, error };
  };
  const updateSingle = async (): Promise<any> => {
    const payload = {
      data: {
        company_id: companyData.company_id,
        settings: {
          ...companyData.settings,
          erp_price_validations: true,
        },
      },
      company_id: companyData.company_id,
      user_id: user_id,
    };

    const { data, error /* message */ } = await apiServices<any>(
      API_SERVICE.post,
      "post",
      payload,
    );

    if (data?.job_id) {
      const jobIdResponse = await getJobId(data.job_id);
      if (jobIdResponse.error) {
        return jobIdResponse;
      }
    }

    if (error) {
      setProcess(false);
    }
    return { data, error };
  };

  const reloadData = async () => {
    setProcess(true);
    await updateSingle();
    await loadingUsers("sku_list");
    await loadSNCustomer();
    setProcess(false);
  };

  return {
    skeltonLoading,
    companyData,
    onPageChange,
    onPerPageChange,
    paginationData,
    permission,
    onAction,
    activeRecordData,
    onFormSubmit,
    onFormOpenChange,
    formPopupOpen,
    tableColumn,
    setTableColumn,
    workflowList,
    tabList,
    activeTab,
    setActiveTab,
    sncErpUomList,
    order_status_list,
    sncCustomerList,
    onErpSettingsTabChange,
    reloadData,
    skuList,
    setSkuList,
  };
};
